<template>
<div v-if="this.authenticated" class="flex mb-5 gap-x-2 text-gray-300 items-center">
  <div>Innlogget som: {{displayName}}</div>
  <div class="justify-center text-lightblue-300 flex items-center">
    <button @click="logout"><span class="mr-2 underline">Logg ut</span><font-awesome-icon icon="sign-out-alt"/></button>
  </div>
</div>
</template>
<script>
export default {
  name: 'LoginPanel',
  props: {
    logoutUrl: {
      type: String,
    },
    userName: {
      type: String,
    },
    authenticated: {
      type: Boolean,
    }
  },
  data() {
    return {
      userRole: '',
      displayName: '',
    };
  },
  mounted() {
    if(this.userName === '' || this.userName.startsWith("...") || this.userName === "Anonym") {
      const params = new URLSearchParams(window.location.search);
      this.userRole = params.has('role') ? params.get('role').toLowerCase() : '';
      this.userId = params.has('id') ? params.get('id') : '';
      if (this.userRole === 'economist') {
        this.displayName = this.$t('schema.schemaPage.roles.economist')
      } else if (this.userRole === 'librarian') {
        this.displayName = this.$t('schema.schemaPage.roles.librarian')
      } else if (this.userRole === 'initiator') {
        this.displayName = this.$t('schema.schemaPage.roles.initiator')
      } else if (this.userRole === 'peer') {
        this.displayName = this.$t('schema.schemaPage.roles.peer')
      } else if (this.userRole === 'other') {
        this.displayName = this.$t('schema.schemaPage.roles.other')
      }else if(this.userRole === ''){
        this.displayName = 'Anonym';
      }
    }else {
      this.displayName = this.userName;
    }
  },
  methods: {
    logout() {
      const res = this.deleteCookies();
      if (res) {
        window.location.href = this.logoutUrl;
      }
    },
    async deleteCookies() {
      try {
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
        };
        const response = await fetch(`${window.location.origin}/api/logout`, requestOptions);
        if (!response.ok) {
          console.log('Error when logging out', response);
          return false;
        }
        return true;
      } catch (error) {
        console.error('Error:', error);
      }
      return false;
    },
  },
};
</script>
